<template>
  <footer class="footer">
    <section class="content"></section>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>

<style lang="scss" scoped>
  .footer {
    height: 100px;
    background: #1690C3;
  }
</style>
